import React from 'react';
import RightArrow from '@/components/Icons/icons/RightArrow';
import { pulseSocialRoutes } from '@/config/baseRoutes';
import { timeAgo } from '@/utils/ts/stringUtils';
import { INotification } from '@Saral-Influencer-Marketing/saral-utils/src/models';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';


interface AdSharePaymentFailedNotificationProps {
  notification: INotification;
  setShowNotificationDropdown: (open: boolean | null) => void;
  markSingleNotificationAsSeen: () => void;
  destination?: 'lowBalance' | 'retry';
}

interface AdSharePayoutFailedContent {
  creatorUsername?: string;
  amount?: string;
  adName?: string;
  body?: string;
  payoutId?: string;
  adId?: string;
}

const DESTINATION_QUERY = {
  lowBalance: {
    page: 'whitelisting',
    adShareLowBalanceModal: 'true',
  },
  retry: {
    page: 'whitelisting',
    adSharePaymentFailedModal: 'true',
  },
} as const;

export const AdSharePaymentFailedNotification = ({
  notification,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
  destination = 'lowBalance',
}: AdSharePaymentFailedNotificationProps) => {
  const content = (notification?.content ?? {}) as AdSharePayoutFailedContent;
  const creatorUsername = content.creatorUsername?.trim() ?? '';
  const payoutAmount = content.amount?.trim() ?? '';
  const adName = content.adName?.trim() ?? '';
  const body = content.body?.trim() ?? '';
  const payoutId = content.payoutId?.trim() ?? '';
  const adId = content.adId?.trim() ?? '';

  const handleViewDetails = () => {
    const params = new URLSearchParams(DESTINATION_QUERY[destination]);

    if (creatorUsername) {
      params.set('adShareCreatorUsername', creatorUsername);
    }
    if (payoutAmount) {
      params.set('adSharePayoutAmount', payoutAmount);
    }
    if (adName) {
      params.set('adShareAdName', adName);
    }
    if (destination === 'retry') {
      if (adId) {
        params.set('adShareAdId', adId);
      }
      if (payoutId) {
        params.set('adSharePayoutId', payoutId);
      }
    }

    markSingleNotificationAsSeen();
    setShowNotificationDropdown(null);
    window.location.href = `${pulseSocialRoutes.campaigns}?${params.toString()}`;
  };

  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div flex items-center justify-center">
        <IconContainer icon="⚠️" bgColor="var(--yellow-y-50)" className="small" />
      </div>
      <div className="text-div">
        <h3 className="title">{notification?.title}</h3>
        {body && <p className="description">{body}</p>}
        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={handleViewDetails}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">View Details</span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default AdSharePaymentFailedNotification;